'use strict';
import React from 'react';
import flux from 'utils/flux';
import Thumb from 'components/thumb';
import Immutable from 'immutable';
import prettyBytes from 'pretty-bytes';

var LicensingListingItem = React.createClass({

    displayName: 'LicensingListingItem',

    propTypes: {
        item: React.PropTypes.object
    },
    shouldComponentUpdate(nextProps) {
        return (Immutable.is(nextProps.item, this.props.item) === false);
    },
    toggleCheck() {
        flux.getActions('basket').toggleLicensing(this.props.item.get('id'));
    },

    updateUsageText(e) {
        flux.getActions('basket').updateLicensingUsageText({
            itemId: this.props.item.get('id'),
            text: e.target.value
        });
    },

    render() {
        const item = this.props.item.toJS();
        const master = item.files && item.files.find( item => 'master' === item.key );
        const MICode = item.meta && item.meta.length && item.meta.find( meta => 'MICode' === meta.key );
        const dimensions = master && master.meta && master.meta.find && master.meta.find( meta => 'Dimensions' == meta.name );
        const resolution = master && master.meta && master.meta.find && master.meta.find( meta => 'Resolution' == meta.name );

        return (
            <div className="listing__item">
                <Thumb className="item__preview" media={this.props.item}/>
                <div className="item__info">
                    <form className="info__actions">
                        <div className="field__checkbox">
                            <input readOnly type="checkbox" checked={item._requestLicense} id={'lic_item_' + item.id} />
                            <label onClick={this.toggleCheck} htmlFor={'lic_item_' + item.id}/>
                        </div>
                    </form>
                    <div className="info__description">
                        <span className="description__title">
                            {item.name}
                        </span>
                        <span className="description__duration">
                            {item.duration}
                        </span>
                        <div className="description__meta">
                            <span className="meta__id">{MICode && MICode.value}</span>
                            <span className="meta__file">
                                {master && master.mimeType}
                                {master && ` / ${prettyBytes( master.size )}`}
                                {dimensions && ` / ${dimensions.value}`}
                                {resolution && ` / ${resolution.value}`}
                            </span>
                        </div>
                    </div>
                </div>
                <form className="item__comment">
                    <textarea onChange={this.updateUsageText} value={item._usageText} placeholder={flux.t('licenseText_placeholder')}/>
                </form>
            </div>
        );
    }
});

module.exports = LicensingListingItem;



// WEBPACK FOOTER //
// ./app/pages/licensing/listing/licensingListingItem.jsx